export default __webpack_public_path__ + "static/media/En_autorización.c0c4ffd1.svg";